import { render, staticRenderFns } from "./SlideShow.vue?vue&type=template&id=47b1e25c&scoped=true"
import script from "./SlideShow.vue?vue&type=script&lang=js"
export * from "./SlideShow.vue?vue&type=script&lang=js"
import style0 from "./SlideShow.vue?vue&type=style&index=0&id=47b1e25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b1e25c",
  null
  
)

export default component.exports